import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { getApp } from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

const root = ReactDOM.createRoot(document.getElementById('root'))

getApp().then((App) => {
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  )
})

// serviceWorkerRegistration.register({
//   onUpdate: (registration) => {
//     if (registration.waiting) {
//       registration.waiting.postMessage({ type: 'SKIP_WAITING' })
//       window.location.reload()
//     }
//   }
// })

serviceWorkerRegistration.unregister()
